import React from "react";
import { Switch, Route, useRouteMatch } from "react-router-dom";
// import ApplicantPage from "./managa-applicant/applicant";
// import ListApplicantPage from "./managa-applicant/list-applicant";
// import ListarSucursalPage from "./gestionar-sucursal/listar-sucursal";
// import SucursalPage from "./gestionar-sucursal/sucursal";
import ListarCategoriaPage from "./gestionar-categoria/listar-categoria";
import CategoriaPage from "./gestionar-categoria/categoria";
import ListarProductoPage from "./gestionar-producto/listar-producto";
import ProductoPage from "./gestionar-producto/producto";

const RouterInventario = () => {
  const { path } = useRouteMatch();
  // console.log('routerAdministracion');
  // console.log(path);
  return (
    // <LayoutConfiguracion>
    <Switch>

      <Route exact path={`${path}/listar-categoria`}>
        <ListarCategoriaPage />
      </Route>
      <Route exact path={`${path}/categoria`}>
        <CategoriaPage />
      </Route>

      <Route exact path={`${path}/listar-producto`}>
        <ListarProductoPage />
      </Route>
      <Route exact path={`${path}/producto`}>
        <ProductoPage />
      </Route>
      {/* 
      <Route exact path={`${path}/listar-insumo`}>
        <ListarInsumoPage />
      </Route>
      <Route exact path={`${path}/insumo`}>
        <InsumoPage />
      </Route>

      <Route exact path={`${path}/listar-presentacion`}>
        <ListarPresentacionPage />
      </Route>
      <Route exact path={`${path}/presentacion`}>
        <PresentacionPage />
      </Route>

      <Route exact path={`${path}/listar-unidad-medida`}>
        <ListarUnidadMedidaPage />
      </Route>
      <Route exact path={`${path}/unidad-medida`}>
        <UnidadMedidaPage />
      </Route>

      <Route exact path={`${path}/listar-categoria`}>
        <ListarCategoriaPage />
      </Route>
      <Route exact path={`${path}/categoria`}>
        <CategoriaPage />
      </Route> */}

      {/* <Route exact path={`${path}/list-applicant`}>
        <ListApplicantPage />
      </Route>
      <Route exact path={`${path}/applicant`}>
        <ApplicantPage />
      </Route> */}

      {/* <Route exact path={`${path}`}>
        <AdministracionIndex />
      </Route> */}

    </Switch>
    // </LayoutConfiguracion>
  );
};

export default RouterInventario;
